import { _ } from "../../polyglot/polyglot.js";
import { widget } from "@foretagsplatsen/widgetjs";

/**
 * Displays information (role, name, email and phone) about a user.
 *
 * @param {user} [spec.user] - The user whose informations are displayed.
 * @param {boolean} [spec.updatePhoneCallback] - Function called when `currentUser` click the update phone button. Don't display the button if null.
 * @param {company} [spec.company] - Current company to get user company role.
 */
const userInfoFormWidget = widget.subclass((that, my) => {
	my.initialize = function (spec) {
		my.user = spec.user;
		my.updatePhoneCallback = spec.updatePhoneCallback;
		my.company = spec.company;
	};

	that.setUser = function (user) {
		my.user = user;
		that.update();
	};

	that.renderContentOn = function (html) {
		if (!my.user) {
			return;
		}

		html.table(
			{ klass: "table table-auto" },
			my.userRowRenderer({
				label: _("User role"),
				value: my.getUserTypePresentationName(),
				dataTestName: "user-role-value",
			}),
			my.userRowRenderer({
				label: _("Name"),
				value: my.user.getName(),
				dataTestName: "name-value",
			}),
			my.userRowRenderer({
				label: _("Email"),
				value: html.a(
					{ href: `mailto:${my.user.getEmail()}` },
					my.user.getEmail(),
				),
				dataTestName: "email-value",
			}),
			my.userRowRenderer({
				label: _("Phone"),
				value: [
					my.user.getPhone() || "-",
					my.editPhoneButtonRenderer(),
				],
				dataTestName: "phone-value",
			}),
			my.userRowRenderer({
				enabled: my.user.isAgencyUser(),
				label: _("Office affiliation"),
				value: (html) =>
					html.render(my.user.getOfficeAffiliation() || "-"),
				dataTestName: "office-affiliation-value",
			}),
		);
	};

	my.editPhoneButtonRenderer = function () {
		return (html) => {
			if (!my.updatePhoneCallback) {
				return;
			}

			html.button(
				{
					klass: "btn-link",
					click: () => my.showPhoneDialog(),
					"data-test": "edit-phone",
				},
				_("Edit"),
			);
		};
	};

	my.showPhoneDialog = function () {
		const model = {
			phone: my.user && my.user.getPhone(),
		};

		my.configure({
			title: _("Update phone number"),
			formSpec: {
				model,
				saveAction: my.updatePhoneCallback,
			},
			formBuilder: (form) => {
				form.input({
					attribute: "phone",
					label: _("Phone"),
					placeHolder: _("+44 XX XXX XX XX"),
				});
			},
		});
	};

	my.userRowRenderer = function ({
		enabled = true,
		label,
		value,
		dataTestName,
	}) {
		if (!enabled) return () => {};

		return (html) =>
			html.tr(
				html.th({ klass: "text-right" }, label),
				html.td({ "data-test": dataTestName }, value || _("N/A")),
			);
	};

	my.getUserTypePresentationName = function () {
		if (my.user.isCompanyUser() && my.company) {
			return my.user.getCompanyRole(my.company).getPresentationName();
		}

		return my.user.getUserTypePresentationName();
	};
});

export default userInfoFormWidget;
